import { Component, OnInit } from '@angular/core'
import { CmsService } from '@spartacus/core'
import { Observable } from 'rxjs'

@Component({
  standalone: false,

  selector: 'vs-additional-resources',
  templateUrl: './additional-resources.component.html',
  styleUrls: ['./additional-resources.component.scss'],
})
export class AdditionalResourcesComponent implements OnInit {
  constructor(private cmsService: CmsService) {}

  linkComponents: any[] = []
  chunkedLinkComponents: any[] = []

  ngOnInit(): void {
    this.cmsService.getContentSlot('Section4').subscribe((res) => {
      for (const comp of res.components) {
        this.linkComponents.push(this.cmsService.getComponentData(comp.uid))
      }
      this.chunkedLinkComponents = this.chunkArray(this.linkComponents, 5)
    })
  }

  chunkArray(myArray, chunkSize) {
    const results = []

    while (myArray.length) {
      results.push(myArray.splice(0, chunkSize))
    }
    return results
  }
}
